import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter014() {
  return <KbChapterPage slug="chapter-014" />;
}

(Chapter014 as unknown as { path: string }).path = "/theory-album/014";
